import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type Theme = 'light' | 'dark' | 'system'

interface ThemeState {
  theme: Theme
  resolvedTheme: 'light' | 'dark'
  setTheme: (theme: Theme) => void
  toggleTheme: () => void
}

const getSystemTheme = (): 'light' | 'dark' => {
  if (typeof window === 'undefined') return 'light'
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? 'dark'
    : 'light'
}

const resolveTheme = (theme: Theme): 'light' | 'dark' => {
  if (theme === 'system') return getSystemTheme()
  return theme
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'system',
      resolvedTheme: 'light',
      setTheme: (theme: Theme) => {
        set({ theme, resolvedTheme: resolveTheme(theme) })
      },
      toggleTheme: () => {
        const currentTheme = get().theme
        const newTheme: Theme =
          currentTheme === 'light'
            ? 'dark'
            : currentTheme === 'dark'
              ? 'system'
              : 'light'
        set({ theme: newTheme, resolvedTheme: resolveTheme(newTheme) })
      },
    }),
    {
      name: 'dreamrealms-theme',
      onRehydrateStorage: () => state => {
        if (state) {
          state.resolvedTheme = resolveTheme(state.theme)
        }
      },
    }
  )
)
